let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ej2Xw")).then(() => parcelRequire('7GQ3N'));